<template>
  <div id="debug-panel" uk-modal>
    <div class="uk-modal-dialog uk-modal-body debug-panel">
      <h2 class="uk-modal-title">{{title}}</h2>
      <ul uk-accordion="multiple: true">
        <li>
          <a class="uk-accordion-title" href="#">Profile Info</a>
          <div class="uk-accordion-content">
            <smex-info></smex-info>
          </div>
        </li>
        <li>
          <a class="uk-accordion-title" href="#">Dependencies</a>
          <div class="uk-accordion-content">
            <dependency-version></dependency-version>
          </div>
        </li>
        <li>
          <a class="uk-accordion-title" href="#">Features</a>
          <div class="uk-accordion-content">
            <feature-picker></feature-picker>
          </div>
        </li>
        <li>
          <a class="uk-accordion-title" href="#">Environment Picker</a>
          <div class="uk-accordion-content">
            <environment-picker></environment-picker>
          </div>
        </li>
        <li v-if="!getEnvironment">
          <a class="uk-accordion-title" href="#">Clear Pending User Resource</a>
          <div class="uk-accordion-content">
            <clear-pending-list></clear-pending-list>
          </div>
        </li>
      </ul>
      <p class="uk-text-right">
        <button class="uk-button uk-button-primary uk-modal-close" type="button">{{$t('general.ok')}}</button>
      </p>
    </div>
  </div>
</template>

<script>
  import Environment from './../../plugins/environment'
  import DependencyVersion from './dependency-version'
  import FeaturePicker from './feature-picker'
  import EnvironmentPicker from './environment-picker'
  import SmexInfo from './smex-info'
  import ClearPendingList from './clear-resources'

  export default {
    name: 'debug-panel',
    components: {
      DependencyVersion,
      FeaturePicker,
      EnvironmentPicker,
      SmexInfo,
      ClearPendingList
    },
    data() {
      return {
        title: 'Debug panel'
      }
    },
    computed: {
      getEnvironment() {
        return Environment.isProd()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .debug-panel {
    background-color: #9cf196;
  }
</style>
